import React, { useState } from 'react';
import { Link } from 'react-router-dom'; // Assuming you use React Router for navigation
import { getAuth, sendPasswordResetEmail } from 'firebase/auth';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope, faSpinner, faCheckCircle, faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';

// Import the auth instance initialized in your firebase.js
import { auth } from '../firebase'; // Adjust the path if necessary

function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState({ type: '', text: '' });
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault(); // Prevent default form submission
    setMessage({ type: '', text: '' }); // Clear previous messages

    if (!email) {
      setMessage({ type: 'warning', text: 'Please enter your email address.' });
      return;
    }

    setLoading(true);

    try {
      // Use the imported auth instance and function
      await sendPasswordResetEmail(auth, email);
      setMessage({
        type: 'success',
        text: `Password reset email sent successfully to ${email}. Please check your inbox (and spam folder).`
      });
      // setEmail(''); // Optional: Clear email field on success
    } catch (error) {
      console.error("Error sending password reset email:", error);
      // Handle specific Firebase Auth errors
      let errorMessage = "Failed to send password reset email. Please try again.";
      if (error.code === 'auth/invalid-email') {
        errorMessage = "The email address format is invalid.";
      } else if (error.code === 'auth/user-not-found') {
        // Standard practice is often to show a generic success message even if user not found
        // to prevent email enumeration attacks. However, showing a specific message can
        // sometimes be better UX if enumeration isn't a major concern for your app.
        // Option 1: Generic success message (more secure)
        // setMessage({ type: 'success', text: `If an account exists for ${email}, a password reset email has been sent. Please check your inbox (and spam folder).` });
        // Option 2: Specific message (potentially less secure)
         errorMessage = "No user found with this email address.";
      } else if (error.code) {
          errorMessage = `${error.code}: ${error.message}`; // Show Firebase error code/message
      } else {
          errorMessage = error.message || errorMessage;
      }
      // Set error message only if we didn't choose Option 1 above
      if(error.code !== 'auth/user-not-found' || errorMessage !== "No user found with this email address.") {
          setMessage({ type: 'danger', text: errorMessage });
      } else {
          // If using Option 1 for user-not-found, set the generic success message here
           setMessage({ type: 'success', text: `If an account exists for ${email}, a password reset email has been sent. Please check your inbox (and spam folder).` });
      }

    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container mt-4">
      <div className="row justify-content-center">
        <div className="col-md-8 col-lg-6">
          <div className="card shadow-sm">
            <div className="card-body p-4">
              <h2 className="card-title text-center mb-4">Reset Password</h2>
              <p className="text-center text-muted mb-4">
                Enter the email address associated with your account, and we'll send you a link to reset your password.
              </p>

              <form onSubmit={handleSubmit}>
                <div className="mb-3">
                  <label htmlFor="email" className="form-label">Email address</label>
                  <div className="input-group">
                     <span className="input-group-text"><FontAwesomeIcon icon={faEnvelope} /></span>
                    <input
                      type="email"
                      className="form-control"
                      id="email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      placeholder="Enter your email"
                      required
                      disabled={loading}
                    />
                   </div>
                </div>

                {/* Message Area */}
                {message.text && (
                  <div className={`alert alert-${message.type || 'info'} d-flex align-items-center mt-3`} role="alert">
                    {message.type === 'success' && <FontAwesomeIcon icon={faCheckCircle} className="me-2 flex-shrink-0" />}
                    {message.type === 'danger' && <FontAwesomeIcon icon={faExclamationTriangle} className="me-2 flex-shrink-0" />}
                    {message.type === 'warning' && <FontAwesomeIcon icon={faExclamationTriangle} className="me-2 flex-shrink-0" />}
                    <div>{message.text}</div>
                  </div>
                )}

                <div className="d-grid mt-4">
                  <button
                    type="submit"
                    className="btn btn-primary"
                    disabled={loading}
                  >
                    {loading ? (
                      <>
                        <FontAwesomeIcon icon={faSpinner} spin className="me-2" />
                        Sending...
                      </>
                    ) : (
                      'Send Password Reset Link'
                    )}
                  </button>
                </div>
              </form>

              <div className="text-center mt-4">
                <Link to="/login">Back to Login</Link> {/* Adjust the path to your login route */}
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ForgotPassword;